import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    DownloadReportAutoGraphParams,
    DownloadReportAutoGraphResponse,
    GetPreTripDetailsResponse,
    GetPreTripsParams,
    GetPreTripsResponse,
    UpdatePreTripPayload,
    GetPreTripsForCompleteDayResponse,
    PreTripUpdateCommentPayload,
} from '@/core/types/tms-graph.types'

export class TmsGraphRepository {
    getPreTrips(params: GetPreTripsParams): Promise<AxiosResponse<GetPreTripsResponse>> {
        return http.get('/tms/api/pre-trips', { params })
    }

    getPreTripDetails(id: number): Promise<AxiosResponse<GetPreTripDetailsResponse>> {
        return http.get(`/tms/api/pre-trips/${id}`)
    }

    updatePreTrip(id: number, payload: UpdatePreTripPayload): Promise<AxiosResponse<void>> {
        return http.post(`/tms/api/pre-trips/${id}/reschedule`, payload)
    }

    createScheduleExcel(payload: FormData): Promise<AxiosResponse<void>> {
        return http.post('/tms/api/pre-trip-schedules/excel', payload)
    }

    downloadReportAutoGraph(
        params: DownloadReportAutoGraphParams
    ): Promise<AxiosResponse<DownloadReportAutoGraphResponse>> {
        return http.get(`/tms/api/pre-trips/report`, { params, responseType: 'blob' })
    }

    getPretripsForCompleteDay(): Promise<AxiosResponse<GetPreTripsForCompleteDayResponse>> {
        return http.get('/tms/api/pre-trips/complete-day')
    }

    updateComment(id: number, payload: PreTripUpdateCommentPayload): Promise<AxiosResponse<void>> {
        return http.put(`/tms/api/pre-trips/comments/${id}`, payload)
    }
}
